import { render, staticRenderFns } from "./StartStreamView.vue?vue&type=template&id=4991a1f0&scoped=true&"
import script from "./StartStreamView.vue?vue&type=script&lang=js&"
export * from "./StartStreamView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4991a1f0",
  null
  
)

export default component.exports